import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {Col, Card} from "react-bootstrap";

const CardTeam = ({id, name, profile, image}) => {
  return (
    <Col className="mb-5 px-5 text-center">
      <Card className="border-0 ">
        <Card.Img
          variant="top"
          src={image}
          height="170px"
          className="mx-auto"
          style={{borderRadius: "50%", width: 180, objectFit: "cover"}}
        />
        <Card.Body>
          <Card.Title>{name}</Card.Title>
          <Card.Subtitle className="mb-2  p-2 text-primary">
            {profile}
          </Card.Subtitle>
          <Card.Text className="text-muted mt-5">
            <span>
              <a href="https://www.facebook.com/" target="blank">
                <i
                  class="fab fa-facebook fa-lg mr-3 text-secondary"
                  style={{fontSize: 25}}
                ></i>
              </a>
              <a href="https://www.twitter.com/" target="blank">
                <i
                  class="fab fa-twitter fa-lg mr-3 text-secondary"
                  style={{fontSize: 25}}
                ></i>
              </a>
              <a href="https://www.instagram.com/" target="blank">
                <i
                  class="fab fa-instagram fa-lg mr-3 text-secondary"
                  style={{fontSize: 25}}
                ></i>
              </a>
              <a href="https://www.linkedin.com/" target="blank">
                <i
                  class="fab fa-linkedin fa-lg mr-3 text-secondary"
                  style={{fontSize: 25}}
                ></i>
              </a>
            </span>
          </Card.Text>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default CardTeam;
